import { Box, Button, Divider, Grid, LinearProgress, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import UserAutoComplete from '../../Components/AutoCompletes/UserAutoComplete';
import { toast } from 'react-toastify';
import GroupRoundedIcon from '@mui/icons-material/GroupRounded';
import UsersVideoCard from './components/UsersVideoCard';
import api from '../../conf/api';
import BackupIcon from '@mui/icons-material/Backup';
import WooglobeIMG from "../../static/images/wooglobeIcon.png"
import axios from 'axios';


const WooglobeSubmition = () => {
    const [selectedUser, setSelectedUser] = useState([]);
    const [compilationData, setCompilationData] = useState({});
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);


    const initalizeCompilationData = {
        question4: "",
        video_title: "",
        category: undefined,
        tags: [],
        videos: [],
        errors: []
    }
    const handleUserChange = (user) => {
        if (user) {
            const old_users = selectedUser.find((usr) => usr.id === user?.id);
            if (!old_users) {
                setSelectedUser((pre) => [...pre, user]);
                setCompilationData((pre) => ({ ...pre, [user?.id]: initalizeCompilationData }));
            } else {
                toast.error("User already selected");
            }
        }
    };
    const handleRemoveUser = (user) => {
        const new_users = selectedUser.filter((usr) => usr.id !== user?.id);
        setSelectedUser(new_users);
    }
    const validateCompilationData = () => {
        let isValid = true;
        const updatedCompilationData = { ...compilationData };

        selectedUser.forEach((user) => {
            const userCompilation = compilationData[user?.id];
            const errors = [];
            console.info(userCompilation);
            if (!userCompilation) {
                return false;
            }
            if (!userCompilation.question4) {
                errors.push("background story/context is missing.");
            }

            if (!userCompilation.video_title) {
                errors.push("Video title is required.");
            }

            if (userCompilation.videos.length === 0) {
                errors.push("At least one video is required.");
            }

            if (!userCompilation.category?.hasOwnProperty("id")) {
                errors.push("Select one of the category");
            }
            if (userCompilation.tags.length === 0) {
                errors.push("At least one tag is required.");
            }
            if (errors.length > 0) {
                isValid = false;
            }
            updatedCompilationData[user?.id] = {
                ...userCompilation,
                errors: errors,
            };
        });

        setCompilationData(updatedCompilationData);
        return isValid;
    };
    const handleSubmit = async () => {
        setLoading(true);
        if (validateCompilationData()) {
            toast.info("Submitting videos for licensing...");
            const updatedCompilationData = { ...compilationData };

            Object.keys(updatedCompilationData).forEach(userId => {
                if (updatedCompilationData[userId].category?.id) {
                    updatedCompilationData[userId].category = updatedCompilationData[userId].category.id;
                }
            });
            api.post("/videos/wooglobe-submitions/", updatedCompilationData, { timeout: 600 * 1000 * 100 })
                .then((res) => {
                    const { status, data } = res;

                    if (status === 200) {
                        let responseData;

                        try {
                            // If backend sent a JSON string, parse it
                            responseData = typeof data.data === "string"
                                ? JSON.parse(data.data)
                                : data.data;
                        } catch (error) {
                            toast.error("Failed to parse response from server.");
                            console.error("Parse Error:", error);
                            return;
                        }

                        // Split into success and error responses
                        const successUsers = [];
                        const errorUsers = [];

                        responseData.forEach((userResp) => {
                            const userId = Object.keys(userResp).find((key) => key !== "status" && key !== "error");
                            const statusCode = userResp.status;

                            if (statusCode === 200) {
                                successUsers.push(userId);
                            } else {
                                errorUsers.push({
                                    userId,
                                    reason: userResp.error || userResp[userId],
                                });
                            }
                        });

                        if (successUsers.length > 0) {
                            toast.success(`Videos licensed successfully for users: ${successUsers.join(", ")}`);
                            // Remove compilation on success
                            const preCompiloations = { ...compilationData };
                            successUsers.forEach(u => {
                                delete preCompiloations[u];
                            })
                            setCompilationData(p => preCompiloations);

                            setSelectedUser(preUser => preUser.filter(u => !successUsers.includes(u.id)));
                        }

                        if (errorUsers.length > 0) {
                            // const preData = compilationData;
                            errorUsers.forEach(({ userId, reason }) => {
                                toast.error(`User ${userId} failed: ${reason}`);
                                // preData[userId] = { ...preData[userId], errors: [reason] }
                            });
                            // Show error ON failed submitions
                            // setCompilationData(preData);
                        }
                    } else {
                        toast.error("Error in licensing videos. Unexpected status code.");
                    }
                })
                .catch((err) => {
                    console.error("API Error:", err);
                    toast.error("Error in licensing videos.");
                }).finally(res => {
                    setLoading(false);
                });
        } else {
            setLoading(false);
            toast.error("Please fix the errors before submitting.");
        }
    };
    const FetchCategories = async () => {
        axios.get(process.env.REACT_APP_WEBSITE + "/apis/categories/").then(res => {
            if (res.status === 200) {
                setCategories(res.data.results);
            }
        }).catch(err => {
        })

    }

    useEffect(() => {
        FetchCategories();
    }, [])


    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                padding: 2
            }}
        >
            <Box display="flex" gap={1} alignItems="center" mb={2}>
                {/* <VerifiedRoundedIcon fontSize="large" color="primary" /> */}
                <Box component="img" src={WooglobeIMG} height={80} />
                <Typography variant="h4" component="h1">Wooglobe Submission</Typography>
            </Box>
            <Box display="flex" flexDirection="column" gap={2} >
                <Box maxWidth={{ xs: 300, md: 400 }} >
                    <UserAutoComplete size="large" value={selectedUser} onChange={handleUserChange} params={{ is_creator: true, page_size: 1000 }} emptySelection selectUserObj />
                </Box>
                <Box hidden={selectedUser.length === 0} sx={{ border: "1px solid #ccc", borderRadius: 2, padding: 2 }}>
                    <Box display={"flex"} gap={1} alignItems="center" mb={2}>
                        <GroupRoundedIcon fontSize="large" color="primary" />
                        <Typography variant="h6" component="h2" >Selected Users</Typography>
                    </Box>
                    <Grid container spacing={1} sx={{ padding: 1 }}>

                        {selectedUser.map((user, index) =>
                            <Grid item key={index}>
                                <UsersVideoCard categories={categories} user={user} onRemove={handleRemoveUser} compilationData={compilationData} setCompilationData={setCompilationData} />
                            </Grid>
                        )}
                    </Grid>
                </Box>
                {Object.keys(compilationData).length > 0 ?
                    <Divider flexItem variant="fullWidth" /> : <></>
                }
                {Object.keys(compilationData).length > 0 ?
                    loading ? <LinearProgress color="error" />
                        :
                        <Button disabled={loading}
                            variant="outlined"
                            color='error'
                            size='large'
                            sx={{ maxWidth: { xs: 300, md: 400 } }}
                            startIcon={<BackupIcon color='error' />}
                            onClick={handleSubmit}

                        >
                            submission
                        </Button>
                    : <></>
                }
            </Box>
        </Box >
    );
};

export default WooglobeSubmition;